import React from 'react';

import Button, { ILink } from 'tbk-components/src/components/Button';
import team1 from '../../assets/img/team-banner-1.jpg';
import team2 from '../../assets/img/team-banner-2.jpg';
import team3 from '../../assets/img/team-banner-3.jpg';
import team4 from '../../assets/img/team-banner-4.jpg';
import team5 from '../../assets/img/team-banner-5.jpg';
import cta1 from '../../assets/img/cta-1.jpg';
import goodwillLogo from '../../assets/img/logo.svg';

export interface ISingleLocationAdditional {
	partnersHeader: string;
	partnersBody: string;
	partnersBody2: string;
	partnersLinks: ILink[];
	communityHeader: string;
	communityBody: string;
	communityLink: string;
}

export interface ISingleLocationAdditionalProps {
	additional: ISingleLocationAdditional;
}

const SingleLocationAdditional: React.FC<ISingleLocationAdditionalProps> = ({
	additional: {
		partnersHeader,
		partnersBody,
		partnersBody2,
		partnersLinks = [],
		communityHeader,
		communityBody,
		communityLink,
	},
}) => (
	<>
		<div className="team-banner">
			<img src={team1} alt="" />
			<img src={team2} alt="" />
			<img src={team3} alt="" />
			<img src={team4} alt="" />
			<img src={team5} alt="" />
		</div>
		<div className="community-involvement">
			<div className="community-involvement__info">
				<h3>{partnersHeader}</h3>
				<p>{partnersBody}</p>
				<p>{partnersBody2}</p>
			</div>
			<div className="community-involvement__links">
				{partnersLinks.map((link, index) => (
					<Button key={index} type="secondary" {...link} />
				))}
			</div>
		</div>
		<div className="social-links">
			<img src={goodwillLogo} alt="Goodwill Logo" />
			<h3>Follow Us</h3>
			<div className="social-icons">
				<a
					href="https://www.instagram.com/goodwillogl/"
					target="_blank"
					aria-label="instagram"
					rel="noreferrer"
				>
					<i className="icon icon-instagram" />
				</a>
				<a
					href="https://www.facebook.com/GoodwillOGL"
					target="_blank"
					aria-label="facebook"
					rel="noreferrer"
				>
					<i className="icon icon-facebook" />
				</a>
				<a
					href="https://www.linkedin.com/company/goodwillogl/"
					target="_blank"
					aria-label="linkedin"
					rel="noreferrer"
				>
					<i className="icon icon-linkedin" />
				</a>
			</div>
			<div className="separator" />
		</div>
		<div className="location-cta">
			<img src={cta1} alt="" />
			<div className="cta-info">
				<h3>{communityHeader}</h3>
				<p>{communityBody}</p>
				{communityLink && (
					<a
						href={communityLink}
						className="btn btn-primary btn-rg"
					>
						Reach Out Today
					</a>
				)}
			</div>
		</div>
	</>
);

export default SingleLocationAdditional;
